import React, { useEffect, useState } from 'react';
import backImg from "../assests/backImg.png";
import { Table, TableRow, TableCell, Box, Typography, Button, Card, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '../assests/addmsglogo.png';
import UserPermissionModal from './UserPermissionModal'; 
import Paginations from '../pagination/Paginations';
import UserPermissionRow from '../tablerow/UserPermissionRow';
import TableComp from '../tablecomp/TableComp';
import { useSelector } from 'react-redux';
import { allSubAdminApi, blockUnblockSubAdmin, createNewSubAdmin, deleteSubAdmin, subAdminByIdApi, updateSubAdmin } from '../../api';
import Loader from '../loader/Loader';
import { toast } from 'react-toastify';
import EditUserPermission from './EditUserPermission';

const UserPermission = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:480px)');
  
  const [open, setOpen] = useState(false); 
  const [editingData, setEditingData] = useState(null); 
  const [admin, setAdmin] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);

  // Fetch all sub-admins
  const allAdmin = async () => {
    try {
      setLoading(true);
      const response = await allSubAdminApi({ token, currentPage });
      setAdmin(response?.data || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching sub-admins:", error);
    }
  };

  // Block/Unblock sub-admin
  const handleBlockResume = async (id, currentLockStatus) => {
    const newLockStatus = !currentLockStatus;
    const action = newLockStatus ? 'block' : 'resume';
    const isConfirmed = window.confirm(`Are you sure you want to ${action} this User/Admin?`);

    if (!isConfirmed) return;

    try {
      const response = await blockUnblockSubAdmin({ token, id, lock: newLockStatus });
      toast.success(response?.message);
      setChange(!change);
    } catch (error) {
      toast.error("An error occurred");
    }
  };

  // Delete sub-admin
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(`Are you sure you want to delete this User/Admin?`);
    if (!isConfirmed) return;

    try {
      const response = await deleteSubAdmin({ token, id });
      toast.success(response?.message);
      setChange(!change); 
    } catch (error) {
      toast.error("An error occurred");
    }
  };

  // Create new sub-admin
  const addAdmin = async (newAdminData) => {
    try {
      const response = await createNewSubAdmin({ token, newAdminData });
      toast.success(response?.message);
      setChange(!change);
      setOpen(false); 
    } catch (error) {
      toast.error("Error creating new admin");
    }
  };

  // Edit sub-admin
  const handleEdit = async (id) => {
    try {
      const response = await subAdminByIdApi({ token, id });
      setEditingData(response?.data || null);
      setOpen(true);
    } catch (error) {
      toast.error("An error occurred while fetching user data");
    }
  };

  useEffect(() => {
    allAdmin();
  }, [currentPage, change]);

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  // const EditSubAdmin=async(updatedData)=>{
  
  //   try {
  //     const response = await updateSubAdmin({token,updatedData})

  //     toast.success(response?.message)
  //     setChange(!change); 
  //     setOpen(false);
  //   } catch (error) {
  //       console.log('Error during API call:', error);
  //     if (error?.status === 500) {
  //       toast.error("Some error occurred");
  //     } else {
  //       toast.error(error?.error);
  //     }
  //   }
  // }

  const EditSubAdmin = async (updatedData) => {
   
    try {
      const response = await updateSubAdmin({
        token,
        id: editingData?._id,
        editedValue: updatedData, 
      });
      toast.success(response?.message || 'Sub-admin updated successfully');
      setChange(!change); 
      setOpen(false);
    } catch (error) {
      console.log('Error during API call:', error);
      toast.error(error.message || 'An error occurred during the update');
    }
  };
  
  

 
  const handleClickOpen = () => {
    setEditingData(null); 
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditingData(null); 
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingData((prevData) => ({ ...prevData, [name]: value }));
  };

  const titles = [
    { title: "Name" },
    { title: "Email" },
    { title: "Mobile No." },
    { title: "Status" },
    { title: "Created Date" },
    { title: "Action" },
  ];

  return (
    <div>
      {loading ? (
        <Loader variant="table" />
      ) : (
        <>
          <Box sx={{ marginTop: '15px', paddingLeft: '10px' }}>
            <Typography
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                gap: '15px',
                width: "8%",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => navigate('/dashboard')}
            >
              <img
                src={backImg}
                alt="backImg"
                style={{ height: "29px", width: "29px" }}
              />
              <Typography
                sx={{ color: "#065F46", fontWeight: "500", fontSize: "20px" }}
              >
                Back
              </Typography>
            </Typography>
          </Box>

          <Card
            backgroundColor={"#fff"}
            borderRadius={"35px"}
            sx={{ padding: "20px", borderRadius: "25px", marginTop: "30px" }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>All Users Permissions</Typography>
              <Button
                onClick={handleClickOpen} // Open modal to create a new user
                sx={{
                  borderRadius: '29px',
                  background: 'linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)',
                  boxShadow: '1px 2px 30px 0px rgba(0, 0, 0, 0.06)',
                  width: '235px',
                  height: '58px',
                  color: 'white',
                  display: 'flex',
                  gap: '5px',
                  textTransform: 'none',
                  fontSize: isSmallScreen ? '12px' : '16px',
                }}
              >
                <img src={AddIcon} alt="Add" style={{ height: '24px', width: '24px', marginRight: '3px' }} />
                Add New Permission
              </Button>
            </Box>

            <TableComp title={titles}>
              {admin.length > 0 ? (
                admin.map((item, index) => (
                  <UserPermissionRow
                    key={item?._id}
                    row={item}
                    index={index}
                    deleteAdmin={() => handleDelete(item?._id)}
                    editedData={() => handleEdit(item?._id)}
                    blockResume={() => handleBlockResume(item?._id, item?.lock)}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={titles.length} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableComp>
            <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
            />
          </Card>
        </>
      )}

      {/* User Permission Modal for Adding/Editing */}
      <UserPermissionModal
        open={open}
        onClose={handleClose}
        editingData={editingData}
        onSave={addAdmin} 
        handleInputChange={handleInputChange}
      />

   
      {editingData && (
        <EditUserPermission
          open={open}
          onClose={handleClose}
          editingData={editingData}
          onSave={EditSubAdmin} 
        />
      )}
    </div>
  );
};

export default UserPermission;
